import React from 'react';
import styles from './Projects.module.css';

const Projects = () => {
  const projects = [
    {
      title: "Raspberry Pi Security Device",
      description: "A custom-built security monitoring device using Raspberry Pi for network intrusion detection and prevention.",
      details: [
        "Implemented Snort IDS/IPS for real-time threat detection",
        "Developed custom dashboard for security event monitoring",
        "Integrated machine learning for anomaly detection",
        "Automated incident response capabilities"
      ],
      technologies: ["Raspberry Pi", "Python", "Snort", "Machine Learning", "React"]
    },
    {
      title: "BlueTech Defenders Platform",
      description: "A comprehensive cybersecurity management platform for monitoring and responding to security incidents.",
      details: [
        "Real-time security event monitoring and analysis",
        "Automated threat detection and response",
        "Integration with multiple security tools and APIs",
        "Custom reporting and analytics dashboard"
      ],
      technologies: ["Node.js", "React", "MongoDB", "Docker", "Kubernetes"]
    },
    {
      title: "BlueTech Empire",
      description: "An enterprise-level security assessment and management solution.",
      details: [
        "Vulnerability scanning and assessment tools",
        "Compliance monitoring and reporting",
        "Asset management and risk assessment",
        "Security policy enforcement"
      ],
      technologies: ["Python", "Django", "PostgreSQL", "AWS", "Terraform"]
    },
    {
      title: "Security Research Publications",
      description: "Various research papers and technical documentation on cybersecurity topics.",
      details: [
        "Zero-day vulnerability research and disclosure",
        "Security tool development and testing",
        "Best practices documentation",
        "Industry conference presentations"
      ],
      technologies: ["Research", "Technical Writing", "Security Tools", "Vulnerability Analysis"]
    }
  ];

  return (
    <div className={styles.container} id="projects">
      <h1 className={styles.title}>Projects</h1>
      <p className={styles.content}>
        Explore my portfolio of cybersecurity projects, demonstrating practical implementation
        of security solutions and research contributions to the field.
      </p>
      <div className={styles.projectsList}>
        {projects.map((project, index) => (
          <div key={index} className={styles.projectItem}>
            <h2 className={styles.projectTitle}>{project.title}</h2>
            <p className={styles.projectDescription}>{project.description}</p>
            <div className={styles.projectDetails}>
              <h3>Key Features:</h3>
              <ul>
                {project.details.map((detail, idx) => (
                  <li key={idx}>{detail}</li>
                ))}
              </ul>
            </div>
            <div className={styles.technologies}>
              <h3>Technologies Used:</h3>
              <div className={styles.techStack}>
                {project.technologies.map((tech, idx) => (
                  <span key={idx} className={styles.techTag}>{tech}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
